import React from "react";

import {
  Card,
  Table,
  Typography,
  Divider,
  Tag,
  Row,
  Col,
  Space,
} from "antd";

import {
  TrophyOutlined,
  UserOutlined,
} from "@ant-design/icons";

import logo from "./savationChristLogo.png";


const {
  Title,
  Text,
} = Typography;




const ScreenGradeSheet = ({
  data
}) => {



  if(!data){
    return null;
  }





  const isLowScore = (score)=>{


    if(
      typeof score === "number"
    ){

      return score < 70;

    }



    if(
      typeof score === "string"
    ){

      return [
        "D",
        "F"
      ].includes(
        score.toUpperCase()
      );

    }


    return false;

  };







  const columns = [


    {
      title:"Subject",

      dataIndex:"subject_name",

      key:"subject_name",

      width:"70%",


      render:(value)=>(

        <Text strong>
          {value}
        </Text>

      )

    },



    {

      title:"Score",

      dataIndex:"formatted_final_score",

      key:"score",

      align:"center",


      render:(score)=>{


        const danger =
        isLowScore(score);



        return (

          <Tag

          color={
            danger
            ?
            "red"
            :
            "blue"
          }


          style={{

            fontWeight:600,

            fontSize:14,

            padding:"4px 12px"

          }}


          >

          {score}

          </Tag>


        );


      }


    }



  ];









  return (



<Card

id="gradesheet"

style={{

maxWidth:900,

margin:"30px auto",

borderRadius:12,

boxShadow:
"0 4px 18px rgba(0,0,0,.12)"

}}

>




{/* SCHOOL HEADER */}


<Row

align="middle"

justify="center"

gutter={20}

>


<Col>


<img

src={logo}

alt="School Logo"

style={{

width:100,

height:100,

objectFit:"contain",

borderRadius:10

}}


/>


</Col>





<Col>


<Title

level={2}

style={{

margin:0,

color:"#814101"

}}

>

Salvation In Christ School System

</Title>
<Text>
Zazay Community, Paynesville City, Monrovia
</Text>

<br/>
<Text>
Contact: +231-770-216-549
</Text>


<br/>


<Text strong>

Student Periodic Report

</Text>



</Col>


</Row>





<Divider/>








{/* STUDENT INFORMATION */}


<Row

gutter={[20,10]}

>


<Col xs={24} md={8}>

<Text>

<UserOutlined/>{" "}

<b>Student:</b>

<br/>

{data.student_name}

</Text>


</Col>





<Col xs={24} md={8}>


<Text>

<b>Grade Class:</b>

<br/>

{data.grade_class_name}

</Text>


</Col>





<Col xs={24} md={8}>


<Text>

<b>Period:</b>

<br/>

{data.period_name}

</Text>


</Col>


</Row>





<Divider/>








{/* SUBJECT TABLE */}



<Table

columns={columns}

dataSource={
data.student_subjects || []
}


rowKey="subject_name"


pagination={false}



bordered



size="middle"


/>







<Divider/>








{/* SUMMARY */}



<Row

gutter={20}

>



<Col xs={24} md={8}>


<Card

size="small"

>

<Text strong>

Average Score

</Text>


<br/>


<Tag

color={
isLowScore(data.average_score)
?
"red"
:
"green"
}


style={{

marginTop:10,

fontSize:16

}}

>

{data.average_score}


</Tag>



</Card>


</Col>






<Col xs={24} md={8}>


<Card

size="small"

>


<Text strong>

Remark

</Text>


<br/>


<Text>

{data.remark || "N/A"}

</Text>


</Card>


</Col>







<Col xs={24} md={8}>


<Card

size="small"

>


<TrophyOutlined/>


<Text strong>

 Rank

</Text>


<br/>


<Text>

{data.rank || "N/A"}

</Text>


</Card>



</Col>


</Row>







<Divider/>







{/* SIGNATURE SECTION */}


<Row

gutter={30}

style={{

marginTop:40

}}

>



<Col span={12}>


<Text>

Teacher Signature

</Text>


<br/><br/>


________________________


</Col>




<Col span={12}>


<Text>

Principal Signature

</Text>


<br/><br/>


________________________


</Col>


</Row>








{/* FOOTER */}



<div

style={{

marginTop:40,

textAlign:"center",

padding:10,

background:"#f5f5f5",

borderRadius:8

}}

>


<Text type="secondary">


Powered by Polu Integrated School Management System


</Text>



</div>






</Card>



  );

};



export default ScreenGradeSheet;